// extracted by mini-css-extract-plugin
export default {"search":"Search_search__dptug","icon":"Search_icon__N9FM-","clear":"Search_clear__5lARN"};